module.exports = __webpack_public_path__ + "static/media/member_message_02.4c9b8966.jpg";